import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { t } from "i18next";

export const OperationDataReportConfirmClose =
    ({ onConfirm, onCancel }:
     { onConfirm: () => void, onCancel: () => void },
    ) => {
    return <Dialog open={true}>
        <DialogTitle>{t("components.operationDataValidation.report.close.title")}</DialogTitle>
        <DialogContent>
            <Typography>
                {t("components.operationDataValidation.report.close.description")}

            </Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={onCancel} variant={"contained"} color={"inherit"}>
                {t("components.operationDataValidation.report.close.noButton")}
            </Button>
            <Button onClick={onConfirm} variant={"contained"} color={"secondary"}>
                {t("components.operationDataValidation.report.close.yesButton")}
            </Button>
        </DialogActions>
    </Dialog>;
};
